import { prop } from 'ramda';
import { useMemo } from 'react';
import { useAppSelector } from 'js/store/hooks';

import * as helpers from './helpers';

export const usePlayerFields = () => {
    const playerFields = useAppSelector(prop('getPlayerInfo'));

    return useMemo(() => {
        if (!playerFields) {
            return helpers.getDefaultPlayerFields();
        }

        const parsedPlayerFields = helpers.parsePlayerFields(playerFields);

        return parsedPlayerFields || helpers.getDefaultPlayerFields();
    }, [playerFields]);
};
